<template>
  <div 
    class="scroll-v" 
    @change="changeHandler"
  >
    <ul class="bar-list">
      <li 
        v-for="item in chartdata" 
        :key="item.name"
      >
        <a 
          v-if="item.link" 
          class="d-flex" 
          :href="item.link" 
          data-testid="bar-chart-link"
        >
          <BarContent 
            :item="item" 
          />
        </a>
        <div
          v-else 
          class="d-flex"
        >
          <BarContent 
            :item="item" 
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import BarContent from "./bar-content.vue";
export default {
  name: "HorizontalBar",
  components:{
    BarContent
  },
  props: {
    chartdata: {
      type: Array,
      required: true,
      validator: value => value.every(({ percentage }) => percentage >= 0 && percentage <= 100),
    },
  },
};
</script>

<style lang="scss" scoped>
.bar-list {
  padding-left: 0;

  li {
    margin-bottom: 15px;
    height: 40px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  a{
    :deep(.bar){
      border: 1px solid transparent;
      transition: border-color .25s ease-in-out;
    }

    &:hover,
    &:focus{
      text-decoration: none;
      outline: none;

      :deep(.bar){
        border-color: #444444;
      }
    }
  }
}
</style>
